export const BRAND_KIT_TAG_COLOR_CIRCLES_COUNT = 2;

export interface BrandKitTagProps {
  brandKitName: string;
  brandKitColors: string[];
  logoThumbSrc: string;
}
